<template>
  <div :class="['input-container', {focused: isLabelCollapsed}]">
    <input
      v-model="modelValue"
      v-bind="$attrs"
      :ref="inputRef"
      :id="inputId"
      :class="[inputClass, {has_error: error}]"
      :name="inputName"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
    />

    <label :for="inputId" class="placeholder-label">{{ label }}</label>
  </div>

  <div v-if="isErrorMessageVisible" class="error_text">{{ errorMessage }}</div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, useTemplateRef } from 'vue';
import useTextInputHook from '@/hooks/useTextInput.js';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  inputRef: {
    type: String,
    default: 'base-text-input-ref',
  },
  inputId: {
    type: String,
    default: 'inputText',
  },
  inputClass: {
    type: String,
    default: '',
  },
  inputName: {
    type: String,
    default: '',
  },
  error: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
});

const modelValue = defineModel({
  type: [String, Number],
});

const baseTextInputRef = useTemplateRef(props.inputRef);

const {
  isLabelCollapsed,
  isErrorMessageVisible,
  addInputAnimationListener,
  removeInputAnimationListener,
  handleInputFocus,
  handleInputBlur,
} = useTextInputHook(modelValue, baseTextInputRef, () => ({ error: props.error, errorMessage: props.errorMessage }));

onMounted(addInputAnimationListener);

onBeforeUnmount(removeInputAnimationListener);
</script>
